<template>
    <div>
        <img id="video" style="width:1920px;height:1080px;background:#FFF;color:#FFF" />
    </div>
</template>
<script>  
export default {
    data(){
        return {
            sound: 0
        }
    },
    created(){
        document.title = '视频播放器'
    },
    mounted(){
        this.openDevice()
        let that = this
        this.vp.on("onEnd",function(params){
			console.info("播放结束:"+JSON.stringify(params));
			//继续重复播放
			that.load();
		});
        window.addEventListener('message', function(event) {
            if (event.origin !== window.location.origin) return;
            
            console.log('Received message:', event.data);
            // 处理消息
            if(event.data === 'openSound'){
                that.sound = 1
                that.openVolume()
            }
            if(event.data === 'closeSound'){
                that.sound = 0
                that.setVolume()
            }
        })
    },
    methods: {
        async openDevice() {
			var result = await this.vp.openDevice();
			console.info("open:" + JSON.stringify(result));
			if(result.result == 0) {
				console.log("打开设备完成");
                this.load();
			} else {
				console.error("打开设备发生错误:" + result.message);
                this.$message({
                    message: '打开设备发生错误,错误码:' + JSON.stringify(result),
                    type: 'error',
                    center: true,
                    duration: 3000,
                    offset: 500
                });
			}
		},
        async load() {
            this.vp.attachElement(video);
			var param = {};
			param.show_type = 2;
            // param.media = "https://vd3.bdstatic.com/mda-kfd892kszuzrqjip/mda-kfd892kszuzrqjip.mp4?v_from_s=hkapp-haokan-tucheng&auth_key=1634282697-0-0-40f4a619cb23f2a737ec99d332d79ef4&bcevod_channel=searchbox_feed&pd=1&pt=3&abtest=";
            param.media = "./wav/publicize.mp4";
            var result = await this.vp.open(param);
			console.info("load:" + JSON.stringify(result));
            if(result.result == 0) {
                console.log("加载视频完成");
                this.sound ? this.openVolume() :this.setVolume()
                this.play();
            } else {
                console.error("加载视频发生错误:" + result.message);
                this.$message({
                    message: '加载视频发生错误,错误码:' + JSON.stringify(result),
                    type: 'error',
                    center: true,
                    duration: 3000,
                    offset: 500
                });
            }
        },
        async play() {
            var param = {};
			var result = await this.vp.play(param);
			console.info("play:" + JSON.stringify(result));
			if(result.result == 0) {
				console.log("开始播放视频");
			} else {
				console.error("播放视频发生错误:" + result.message);
                this.$message({
                    message: '播放视频发生错误,错误码:' + JSON.stringify(result),
                    type: 'error',
                    center: true,
                    duration: 3000,
                    offset: 500
                });
			}
        },
        async setVolume(){
			var param = {};
			param.volume = 0;
			var result = await this.vp.setVolume(param);
			console.info(JSON.stringify(result));
			if(result.result==0){
				console.log("设置声音大小" + param.volume);
			}else{
				console.error("发生错误:"+result.message);
			}
		},
        async openVolume(){
			var param = {};
			param.volume = 60;
			var result = await this.vp.setVolume(param);
			console.info(JSON.stringify(result));
			if(result.result==0){
				console.log("设置声音大小" + param.volume);
			}else{
				console.error("发生错误:"+result.message);
			}
		}
        
    }
}
</script>
<style lang="less" scoped>

</style>


